import { createBrandPreset } from './brands/createBrandPreset.js';
import { resolveBrandProfile } from './brands/registry.js';
import autoflowPreset from './brands/autoflow.js';
import bayhivePreset from './brands/bayhive-preset.js';

const PRIMEVUE_PRESETS = {
  autoflow: autoflowPreset,
  bayhive: bayhivePreset,
};

export const normalizeUiBrand = (brand) => {
  return Object.prototype.hasOwnProperty.call(PRIMEVUE_PRESETS, brand) ? brand : 'autoflow';
};

export const syncDocumentUiBrand = (brand) => {
  if (typeof document === 'undefined') {
    return normalizeUiBrand(brand);
  }

  const normalizedBrand = normalizeUiBrand(brand);
  document.documentElement.setAttribute('data-ui-brand', normalizedBrand);

  return normalizedBrand;
};

const configuredPresets = new Map();
export const resolvePrimeVuePreset = (brand, requested) => {
  const application = normalizeUiBrand(brand);
  const profile = resolveBrandProfile(application, requested);
  if (!profile.colors && !profile.fontFamily && !profile.radius && !profile.tokens) {
    return PRIMEVUE_PRESETS[application];
  }
  if (!configuredPresets.has(profile.id)) {
    configuredPresets.set(profile.id, createBrandPreset(PRIMEVUE_PRESETS[application], profile));
  }
  return configuredPresets.get(profile.id);
};

// Runtime shop themes are validated data, never arbitrary CSS or application identities.
export const createShopPrimeVuePreset = (profile) => createBrandPreset(bayhivePreset, profile);
